import { render, staticRenderFns } from "./newInStore.vue?vue&type=template&id=ad66114a&scoped=true"
import script from "./newInStore.vue?vue&type=script&lang=js"
export * from "./newInStore.vue?vue&type=script&lang=js"
import style0 from "./newInStore.vue?vue&type=style&index=0&id=ad66114a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad66114a",
  null
  
)

export default component.exports